const pathSplit = (pathName, routesNameCustom) => {
  // const [, id, routeName, param] = pathName.split("/");

  const splitted = pathName.split("/");

  if (routesNameCustom) {
    const findRoute = splitted.indexOf(routesNameCustom);

    if (findRoute >= 0) {
      // const [id, routeName] = routeAll;

      const routeName = splitted[findRoute];
      const id = splitted.slice(0, findRoute).join("");

      return {
        routeName,
        id
      };
    }
    return {
      routeName: routesNameCustom,
      id: ""
    };
  } else {
    return {
      routeName: "",
      id: splitted[1],
      path: splitted[2]
    };
  }
};

export default pathSplit;
